import { Suspense } from 'react';
import { Await, useLoaderData, useOutlet } from 'react-router-dom';

import { User } from '@models/user.model';
import { AuthProvider, useAuth } from '@providers/authProvider';

const AuthLayout = () => {
  const outlet = useOutlet();
  const { userAccount } = useAuth();
  const userPromise = useLoaderData() as { user: Promise<User | null> };

  console.log('AuthLayout userAccount', userAccount);
  return (
    <Suspense fallback={<div />}>
      <Await
        resolve={userPromise.user}
        errorElement={<div>Something went wrong</div>}
        children={user => {
          console.log('AuthLayout user', user);
          return <AuthProvider userData={user}>{outlet}</AuthProvider>;
        }}></Await>
    </Suspense>
  );
};

export default AuthLayout;
